import api from '@/api/products/trustpilotEmail';

const state = () => ({
  sendTrustpilotReviewEmailLoading: false,
  sendTrustpilotReviewEmailError: false,
  sendTrustpilotReviewEmailErrorResponse: null
});

const mutations = {
  SEND_TRUSTPILOT_REVIEW_EMAIL_BEGIN(state) {
    state.sendTrustpilotReviewEmailLoading = true;
    state.sendTrustpilotReviewEmailError = false;
    state.sendTrustpilotReviewEmailErrorResponse = null;
  },
  SEND_TRUSTPILOT_REVIEW_EMAIL_SUCCESS(state) {
    state.sendTrustpilotReviewEmailLoading = false;
  },
  SEND_TRUSTPILOT_REVIEW_EMAIL_ERROR(state, err) {
    state.sendTrustpilotReviewEmailLoading = false;
    state.sendTrustpilotReviewEmailError = true;
    state.sendTrustpilotReviewEmailErrorResponse = err;
  }
};

const actions = {
  async sendTrustpilotReviewEmail({ commit, dispatch }, account_id) {
    commit('SEND_TRUSTPILOT_REVIEW_EMAIL_BEGIN');
    try {
      const response = await api.sendTrustpilotReviewEmail(account_id);
      commit('SEND_TRUSTPILOT_REVIEW_EMAIL_SUCCESS');
      dispatch('alerts/setAlert', {type: 'success', message: response.data.message}, {root: true});
    } catch(err) {
      commit('SEND_TRUSTPILOT_REVIEW_EMAIL_ERROR', err.response.data.message);
      dispatch('alerts/setAlert', {type: 'error', message: err.response.data.message}, {root: true});
    }
  }
};

const getters = {
  getSendTrustpilotReviewEmailLoading: state => state.sendTrustpilotReviewEmailLoading,
  getSendTrustpilotReviewEmailError: state => state.sendTrustpilotReviewEmailError,
  getSendTrustpilotEmailErrorResponse: state => state.sendTrustpilotReviewEmailErrorResponse
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
